import {Page} from "@indebted/components/Page"
import {Link, Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useTranslation} from "react-i18next"

import {nextPage} from "../Navigator"
import {usePaymentArrangementId} from "../usePaymentArrangementId"

export function FailedPage() {
	const {t} = useTranslation()
	const paymentArrangementID = usePaymentArrangementId()

	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("payment_arrangement_status.setup_failed.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center" variant="body1">
					<Link href={nextPage("payment-method", paymentArrangementID)} rel="noopener noreferrer">
						{t("payment_arrangement_status.setup_failed.retry.link_text")}
					</Link>
				</Typography>
			</Grid>
		</Page>
	)
}
